import { render, staticRenderFns } from "./SuccessBanner.vue?vue&type=template&id=ef4d0066&scoped=true&"
import script from "./SuccessBanner.vue?vue&type=script&lang=js&"
export * from "./SuccessBanner.vue?vue&type=script&lang=js&"
import style0 from "./SuccessBanner.vue?vue&type=style&index=0&id=ef4d0066&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef4d0066",
  null
  
)

export default component.exports